// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"e457d986","435":"edb9ba30","445":"4c767840"}[chunkId] + ".chunk.js";
};